import { render, staticRenderFns } from "./TbUsers.vue?vue&type=template&id=0ef73c1c&scoped=true"
import script from "./TbUsers.vue?vue&type=script&lang=js"
export * from "./TbUsers.vue?vue&type=script&lang=js"
import style0 from "./TbUsers.vue?vue&type=style&index=0&id=0ef73c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef73c1c",
  null
  
)

export default component.exports